type PlayType = iconProps & {
  id?: string
}

function Play(props: PlayType) {
  const fill = props.fill || 'currentColor'
  const strokewidth = props.strokewidth || 2
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'Play'
  const id = props.id || ''

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height={height}
      width={width}
      viewBox='0 0 32 33'
      fill='none'
      className={props.className}
    >
      <title>{title}</title>
      <path
        d='M6.66602 29.8327V3.16602L27.9994 16.4994L6.66602 29.8327Z'
        stroke={fill}
        strokeWidth={strokewidth}
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M6.66602 29.8327V3.16602L27.9994 16.4994L6.66602 29.8327Z'
        fill={fill}
        strokeWidth={strokewidth}
        strokeMiterlimit='10'
        strokeLinecap='square'
        clipPath={`url(#${id})`}
      />

      <clipPath id={id}>
        <rect
          x='0'
          y='0'
          fill={fill}
          height='100%'
          className='w-0 transition-all duration-500 group-hover:w-full group-focus:w-full'
        />
      </clipPath>
    </svg>
  )
}

export default Play
